import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TagActionsMenu } from '../../SpecialTag/TagActionsMenu';
import { variant } from '../../SpecialTag/types';
import { useIsLandscapeTablet } from '../../../../hooks/useMediaBreakPoints';
import { WorkedInRouteRef } from '../../../../types/surveillanceRoute';

type WorkedInRoutePillsProps = { routes?: WorkedInRouteRef[] };

/**
 * Spec 2026-09-23 § 5: la pill verde «Vinculado con Su.NN» de la OT, en la
 * card de cada actuación o accidente que hizo la patrulla de ese recorrido.
 * Una sola acción (ver) → la pill entera navega. Sin desvincular: el vínculo
 * se decide en la OT padre.
 */
export const WorkedInRoutePills = ({ routes = [] }: WorkedInRoutePillsProps) => {
  const { t } = useTranslation(['pages']);
  const navigate = useNavigate();
  const isLandscapeTablet = useIsLandscapeTablet();
  return (
    <>
      {routes.map((route) => (
        <TagActionsMenu
          key={route.id}
          variant={variant.LinkedToSegment}
          sizeTag={isLandscapeTablet ? 'small' : 'default'}
          title={t('pages:surveillance.linkedWith', {
            roid: route.roid || route.name || '',
          })}
          actions={[
            {
              icon: 'view',
              label: t('pages:surveillance.seeRoute'),
              onClick: () => navigate(`/surveillance-route/${route.id}`),
            },
          ]}
        />
      ))}
    </>
  );
};
